import { render } from "./AcceptationCession.vue?vue&type=template&id=645f5758&ts=true"
import script from "./AcceptationCession.vue?vue&type=script&lang=ts"
export * from "./AcceptationCession.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__